import { Component } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { CommonHttpService } from '../../../shared/services/common-http/common-http.service';
import { ConfirmationModelComponent } from '../../../shared/components/confirmation-model/confirmation-model.component';
import { CommunicationService } from 'src/app/shared/services/communication/communication.service';
import { Modalconfig } from '../../../shared/constants';
import { Playbook } from 'src/app/shared/model/playbook.models';

@Component({
    selector: 'app-v-builder-playbook-modal',
    templateUrl: './v-builder-playbook-modal.component.html',
    styleUrls: ['./v-builder-playbook-modal.component.scss'],
    standalone: false
})
export class VBuilderPlaybookModalComponent {

  verb: string;
  playbook: Playbook;
  categoryId: number;
  order: number;
  confirmModalRef: BsModalRef;

  constructor(
    private modalRef: BsModalRef,
    private modalService: BsModalService,
    private commonHttpService: CommonHttpService,
    private communicationService: CommunicationService
  ) { }


  /**
   * To save new or edited playbook
   */
  savePlaybook() {
    if (this.verb === 'Add') {
      this.playbook.companyId = 0;
      this.playbook.order = this.order;
      this.playbook.categoryId = null;
      this.playbook.isDraftMode = false;
      this.playbook.isAvailableOffline = false;
      this.playbook.conversationsAvailable = false;
      this.playbook.emailRelease = false;
      this.playbook.isTutorialPlaybook = true;
      this.playbook.languages = [];
      this.commonHttpService.post<Playbook, Playbook>(
        {
          uri: '/api/Playbooks/AddPlaybook',
          object: this.playbook,
          message: {
            successMessage: 'Tutorial playbook successfully added.',
          }
        }).subscribe((response) => {
          this.communicationService.setPlabookSettingSubject({
            modalType: 'tutorialPlaybook',
            type: 'add',
            value: response
          });
        });
    } else if (this.verb === 'Edit') {
      this.playbook.conversationsAvailable = false;
      this.playbook.languages = [];
      this.commonHttpService.put<Playbook, Playbook>(
        {
          uri: '/api/Playbooks/UpdatePlaybook',
          object: this.playbook,
          message: {
            successMessage: 'Tutorial playbook successfully updated.'
          }
        }).subscribe((response) => {
          this.communicationService.setPlabookSettingSubject({
            modalType: 'tutorialPlaybook',
            type: 'update',
            value: response
          });
        });
    }
    this.closeModal();
  }

  /**
   * To delete playbook
   */
  deletePlaybook() {
    if (this.playbook.id && this.playbook.companyId) {
      const initialState = {
        msg: 'Are you sure you want to delete this playbook?'
      };
      this.confirmModalRef = this.modalService.show(ConfirmationModelComponent,
        Object.assign({ initialState }, { class: 'custom-modal' }, Modalconfig));
      this.confirmModalRef.content.onclose.subscribe((isDelete) => {
        if (isDelete) {
          this.commonHttpService.deleteWithBody(
            {
              uri: '/api/Playbooks/DeletePlaybook',
              object: {
                id: this.playbook.id,
                companyId: this.playbook.companyId
              },
              message: {
                successMessage: 'Playbook deleted successfully.'
              }
            }).subscribe((response) => {
              this.communicationService.setPlabookSettingSubject({
                modalType: 'tutorialPlaybook',
                type: 'delete',
                value: this.playbook.id
              });
            });
        }
        this.confirmModalRef.hide();
        this.closeModal();
      });
    }
  }

  closeModal() {
    this.modalRef.hide();
  }
}
